<div class="bank-transactions-portal-page" [hidden]="transactionId">
    <app-portal-list-surface
      title="TRANSACTIONS"
      subtitle="Manage linked bank transactions for this fund">
      <app-portal-toolbar portalListHeader class="transactions-header-actions">
        <div portalToolbarRight>
        <mat-form-field
          class="transactions-date-range"
          [ngClass]="{'transactions-date-range--active' : (startDate.value || endDate.value)}">
          <mat-date-range-picker
            #picker
            (closed)="dateRangeFilter(startDate, endDate)">
          </mat-date-range-picker>
          <mat-datepicker-toggle matIconPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-input
            [formGroup]="range"
            [rangePicker]="picker"
            [max]="maxDate">
            <input matStartDate formControlName="start" placeholder="Start date" #startDate readonly />
            <input matEndDate formControlName="end" placeholder="End date" #endDate readonly />
          </mat-date-range-input>
          <button
            matIconSuffix
            type="button"
            class="transactions-date-range__clear"
            *ngIf="startDate.value || endDate.value"
            (click)="clearFilter('dateRange')">
            <img src="assets/images/cross_icon_grey.svg" height="19" width="19" alt="Clear date range" />
          </button>
        </mat-form-field>

        <app-filter-menu
          class="transactions-filter-menu"
          [filterMenuLabel]="'Filters'"
          [filterMenuItems]="filterMenuItems"
          [pageCustomPanelClass]="'bank-transaction'"
          (filtersChanged)="filterApplied($event)">
        </app-filter-menu>

        <mat-form-field class="portal-transactions-search-field">
          <img src="assets/images/search.svg" alt="search" matPrefix />
          <input
            matInput
            placeholder="Search"
            [(ngModel)]="search"
            (keyup)="isPageLoading = true; searchHandler()"
            (keyup)="handleBackspaceClear($event)"
            autocomplete="off" />
          <button
            matSuffix
            type="button"
            class="portal-transactions-search-field__clear"
            *ngIf="search"
            (click)="clearFilter('search'); search = ''">
            <img src="assets/images/cross_icon_grey.svg" height="20" width="20" alt="clear" />
          </button>
        </mat-form-field>

        <button
          class="portal-primary-btn transactions-download-btn"
          type="button"
          (click)="downloadExcel()"
          [disabled]="isDownloading"
          [matTooltip]="
            isFilterApplied()
              ? 'Export filtered transactions'
              : 'Export transactions for last 6 months'
          ">
          <ng-container *ngIf="!isDownloading; else spinner">
            <mat-icon>download</mat-icon>
            <span>Download</span>
          </ng-container>
        </button>
        </div>
      </app-portal-toolbar>

      <app-portal-table
        [columns]="transactionColumns"
        [rows]="dataSource.data"
        [loading]="isLoading || isPageLoading"
        [sortActive]="sortActive"
        [sortDirection]="portalSortDirection"
        emptyTitle="No bank transactions found"
        emptyDescription="Try adjusting your filters or check again after the next bank sync."
        (sortChange)="portalSortChange($event)"
        (rowClick)="viewTransactions($event)">
        <ng-template portalTableCell="executionDate" let-row>
          {{ row.executionDate ? commonService.formateDate(row.executionDate) : '-' }}
        </ng-template>

        <ng-template portalTableCell="purpose" let-row>
          <span class="transaction-purpose">
            {{ row.description ? row.description : row.remittanceInformation ? row.remittanceInformation : '-' }}
          </span>
        </ng-template>

        <ng-template portalTableCell="amount" let-row>
          <span [ngClass]="getAmountClass(row.amount)">
            {{
              (row.amount
                | number : '1.2'
                | convertWithDecimal : selectedVehicle : false : false : '') + ' €'
            }}
          </span>
        </ng-template>

        <ng-template portalTableCell="currency" let-row>
          <span class="transaction-strong">{{ row.currency || '-' }}</span>
        </ng-template>

        <ng-template portalTableCell="partnerName" let-row>
          <span class="transaction-strong">{{ row.counterpartName || '-' }}</span>
        </ng-template>

        <ng-template portalTableCell="bankAccount" let-row>
          <span class="transaction-muted">{{ row.bankName || '-' }}</span>
        </ng-template>

        <ng-template portalTableCell="attachment" let-row>
          <ng-container *ngIf="row?.invoiceList?.length; else showLink">
            <span
              class="transaction-icon-action"
              role="button"
              tabindex="0"
              [matMenuTriggerFor]="unlinkMenu"
              (click)="$event.stopPropagation()"
              (keydown.enter)="$event.stopPropagation()"
              (keydown.space)="$event.preventDefault(); $event.stopPropagation()">
              <img src="assets/images/check_icon.svg" alt="Linked invoice" width="20" height="20" />
            </span>
            <mat-menu
              class="unlink-mat-menu"
              #unlinkMenu="matMenu"
              xPosition="before"
              [mat-menu-action-position]="'unlink'">
              <button mat-menu-item type="button" (click)="unlinkDialog(row)">
                <img src="assets/images/unlink_icon.svg" alt="" height="20" width="20" />
                <span>Unlink</span>
              </button>
            </mat-menu>
          </ng-container>

          <ng-template #showLink>
            <span
              class="transaction-icon-action"
              role="button"
              tabindex="0"
              (click)="attachmentPopup(row); $event.stopPropagation()"
              (keydown.enter)="attachmentPopup(row); $event.stopPropagation()"
              (keydown.space)="$event.preventDefault(); attachmentPopup(row); $event.stopPropagation()">
              <img src="assets/images/link_icon.svg" alt="Link invoice" width="20" height="20" />
            </span>
          </ng-template>
        </ng-template>

        <app-portal-table-footer
          portalTableFooter
          [total]="totalRecords || 0"
          [pageIndex]="pageIndex"
          [pageSize]="pageSize"
          [visibleCount]="dataSource.data.length"
          [pageSizeOptions]="pageSizeOptions"
          (pageIndexChange)="setPageIndex($event)"
          (pageSizeChange)="setRowsPerPage($event)">
        </app-portal-table-footer>
      </app-portal-table>
    </app-portal-list-surface>
</div>

<ng-template #spinner>
  <span class="loader"></span>
</ng-template>
